import { routes } from '~/shared/constants/routes';
import { type Mode } from '~/shared/store/mode';

const getStaticRoutePrefix = (route: string) => route.split('/:')[0];

const matchesPathPrefix = (pathname: string, prefix: string) => {
    return pathname === prefix || pathname.startsWith(`${prefix}/`);
};

const payoutPathPrefixes = [routes.payout, routes.cascades, getStaticRoutePrefix(routes['payout-trader'])];

export const getModeByPathname = (pathname: string): Mode | null => {
    if (matchesPathPrefix(pathname, routes.payin)) {
        return 'payin';
    }

    if (
        payoutPathPrefixes.some((prefix) => {
            return matchesPathPrefix(pathname, prefix);
        })
    ) {
        return 'payout';
    }

    return null;
};
